// src/components/AnasayfaSection.js
import React, { useEffect, useState, useMemo } from "react";
import "./AnasayfaSection.css";

const baseUrl = "https://apiportal.mbsays.com/public/api";
const token = sessionStorage.getItem("authToken");
const storedUser = JSON.parse(sessionStorage.getItem("user") || "{}");
const isAdmin = storedUser.role === "admin";

const headers = { Authorization: `Bearer ${token}` };

const AnasayfaSection = () => {
  /* ---------- STATE ---------- */
  const [summary, setSummary] = useState({});
  const [myAssets, setMyAssets] = useState([]);
  const [allAssets, setAllAssets] = useState([]);
  const [users, setUsers] = useState([]);
  const [assignSel, setAssignSel] = useState({});        // assetId → userId
  const [addOpen, setAddOpen] = useState(false);         // modal
  const [newAsset, setNewAsset] = useState({             // yeni kayıt formu
    name: "",
    type: "",
    serial_number: "",
  });
  const [loading, setLoading] = useState(true);

  /* id‑name eşlemesi */
  const usersMap = useMemo(
    () => Object.fromEntries(users.map((u) => [u.id, u.name])),
    [users]
  );
const [vacationDays, setVacationDays] = useState(storedUser?.vacation_days || 0);

  /* ---------- API ---------- */
  useEffect(() => {
    (async () => {
      try {
        if (isAdmin) {
          const uRes = await fetch(`${baseUrl}/users`, { headers });
          setUsers(await uRes.json());
        }

        /* envanteri çek */
        await refreshAssets();

        /* kullanıcının zimmetleri */
        if (!isAdmin) {
          const myRes = await fetch(`${baseUrl}/my-assets`, { headers });
          setMyAssets(await myRes.json());
        }

        setLoading(false);
      } catch (e) {
        console.error("Dashboard verileri alınamadı:", e);
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ---------- Admin işlemleri ---------- */
  const assignAsset = async (assetId) => {
    const userId = assignSel[assetId];
    if (!userId) return;

    try {
      await fetch(`${baseUrl}/assets/${assetId}/assign`, {
        method: "POST",
        headers: { ...headers, "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: Number(userId) }),
      });
      await refreshAssets();
    } catch {
      alert("Atama başarısız");
    }
  };

  const returnAsset = async (assetId) => {
    if (!window.confirm("Cihaz iade alınsın mı?")) return;
    try {
      await fetch(`${baseUrl}/assets/${assetId}/unassign`, {
        method: "DELETE",
        headers,
      });
      await refreshAssets();
    } catch {
      alert("İade başarısız");
    }
  };

  const createAsset = async (e) => {
    e.preventDefault();
    const { name, type, serial_number } = newAsset;
    if (!name || !type || !serial_number) return;

    try {
      await fetch(`${baseUrl}/assets`, {
        method: "POST",
        headers: { ...headers, "Content-Type": "application/json" },
        body: JSON.stringify({ name, type, serial_number }),
      });
      await refreshAssets();
      closeAddModal();
    } catch {
      alert("Kayıt başarısız");
    }
  };

  const refreshAssets = async () => {
    const res = await fetch(`${baseUrl}/assets`, { headers });
    const data = await res.json();
    setAllAssets(data);

    /* sayaçları güncelle */
    const tmp = {};
    data.forEach((a) => {
      if (!tmp[a.type]) tmp[a.type] = { idle: 0, assigned: 0 };
      if (a.status === 1) tmp[a.type].assigned += 1;
      else tmp[a.type].idle += 1;
    });
    setSummary(tmp);
  };

  /* ---------- Modal helpers ---------- */
  const openAddModal = () => setAddOpen(true);
  const closeAddModal = () => {
    setAddOpen(false);
    setNewAsset({ name: "", type: "", serial_number: "" });
  };
  const handleNewChange = ({ target: { name, value } }) =>
    setNewAsset((p) => ({ ...p, [name]: value }));

  /* ---------- Yardımcı ---------- */
  const fmtDate = (d) =>
    d ? new Date(d).toLocaleDateString("tr-TR") : "-";

  /* ---------- UI ---------- */
  if (loading) return <p style={{ padding: 40 }}>Yükleniyor…</p>;

  return (
    <div className={`anasayfa-container ${isAdmin ? "admin-layout" : ""}`}>
      {/* -------- SOL BLOK -------- */}
      <div className="left-content">
        {/* İzin (statik) 
        <h2>İzin Bilgilerim</h2>
        <div className="izin-cards">
          <div className="izin-card">
            <h3>Kalan İzin</h3>
            <div className="izin-value">{vacationDays}</div>
            <div className="izin-subtitle">Gün</div>
          </div>
          <div className="izin-card">
            <h3>Hak Edeceği Gün</h3>
            <div className="izin-value">{vacationDays + 14}</div>
            <div className="izin-subtitle">04.01.2025</div>
          </div>
          <div className="izin-card">
            <h3>Yaklaşan İzin</h3>
            <div className="izin-value">-</div>
          </div>
        </div>
*/}
        {/* ENVANTER ÖZETİ / KULLANICI ZİMMETLERİ */}
        {!isAdmin && (
          <>
            <h2>Envanter Özeti</h2>
            <div className="zimmet-scroller">
              {Object.entries(summary).map(([type, s]) => (
                <div className="zimmet-box" key={type}>
                  <div className="zimmet-title">{type}</div>
                  <div className="zimmet-status">
                    Kullanımda: {s.assigned}
                    <br />
                    Boşta: {s.idle}
                  </div>
                </div>
              ))}
              {!Object.keys(summary).length && (
                <p style={{ padding: "1rem" }}>Envanter bulunamadı.</p>
              )}
            </div>

            <h2>Zimmetlerim</h2>
            {myAssets.length ? (
              <ul className="my-assets-list">
                {myAssets.map((a) => (
                  <li key={a.id}>
                    {a.name} — SN: {a.serial_number} ({fmtDate(a.created_at)}
                    'den beri)
                  </li>
                ))}
              </ul>
            ) : (
              <p style={{ padding: "0.5rem" }}>Üzerinizde cihaz bulunmuyor.</p>
            )}
          </>
        )}

        {/* ADMIN: ZİMMET TABLOSU */}
        {isAdmin && (
          <>
            <h2 style={{ marginTop: 24 }}>Zimmet Listesi</h2>
            <button className="add-btn" onClick={openAddModal}>
              Yeni Varlık Ekle
            </button>

            {allAssets.length ? (
              <table className="asset-table wide">
                <thead>
                  <tr>
                    <th>Ad</th>
                    <th>Tip</th>
                    <th>Seri No</th>
                    <th>Durum</th>
                    <th>Kullanıcı</th>
                    <th>Tarih</th>
                    <th>Aksiyon</th>
                  </tr>
                </thead>
                <tbody>
                  {allAssets.map((a) => (
                    <tr key={a.id}>
                      <td>{a.name}</td>
                      <td>{a.type}</td>
                      <td>{a.serial_number}</td>
                      <td>{a.status === 1 ? "Kullanımda" : "Boşta"}</td>
                      <td>{usersMap[a.user_id] || "-"}</td>
                      <td>{fmtDate(a.created_at)}</td>
                      <td className="actions">
                        {a.status === 0 ? (
                          <>
                            <select
                              value={assignSel[a.id] || ""}
                              onChange={(e) =>
                                setAssignSel({
                                  ...assignSel,
                                  [a.id]: e.target.value,
                                })
                              }
                            >
                              <option value="">Kişi seç</option>
                              {users.map((u) => (
                                <option key={u.id} value={u.id}>
                                  {u.name}
                                </option>
                              ))}
                            </select>
                            <button
                              className="assign-btn"
                              disabled={!assignSel[a.id]}
                              onClick={() => assignAsset(a.id)}
                            >
                              Ata
                            </button>
                          </>
                        ) : (
                          <button
                            className="return-btn"
                            onClick={() => returnAsset(a.id)}
                          >
                            İade Al
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p style={{ padding: "0.5rem" }}>Envanter boş.</p>
            )}
          </>
        )}

      </div>

      {/* -------- SAĞ BLOK (sadece kullanıcı) -------- */}
      {!isAdmin && (
        <div className="right-content">
          <h3>Neler Oluyor?</h3>
          <div className="event-box">
            <h4>Etkinlik</h4>
            <div className="event-date">25.03.2025 – 14:00</div>
            <div className="event-desc">2025 Yılı Ara Değerlendirmesi</div>
          </div>
          <div className="event-box">
            <h4>Etkinlik</h4>
            <div className="event-date">10.04.2025 – 09:30</div>
            <div className="event-desc">Proje Sunumu</div>
          </div>
        </div>
      )}

      {addOpen && (
  <div className="modal-overlay" onClick={closeAddModal}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
      <button className="modal-close-btn" onClick={closeAddModal}>×</button>
      <h3>Yeni Varlık Ekle</h3>
      <form onSubmit={createAsset} className="add-form">
        <label>Ad</label>
        <input
          name="name"
          value={newAsset.name}
          onChange={handleNewChange}
          required
        />
        <label>Tip</label>
        <input
          name="type"
          value={newAsset.type}
          onChange={handleNewChange}
          required
        />
        <label>Seri No</label>
        <input
          name="serial_number"
          value={newAsset.serial_number}
          onChange={handleNewChange}
          required
        />
        <div className="modal-btns">
          <button type="submit" className="assign-btn">Kaydet</button>
          <button type="button" className="return-btn" onClick={closeAddModal}>İptal</button>
        </div>
      </form>
    </div>
  </div>
)}

    </div>
  );
};

export default AnasayfaSection;
